import {
  FormLabel,
  Stack,
  Text,
  Flex,
  Button,
  IconButton,
  Box,
} from '@chakra-ui/react';
import { InputText } from '../Input';
import { IoAddCircleOutline, IoTrashOutline } from 'react-icons/io5';
import React from 'react';

function GridOptions({ index, register, errors, gridRows, gridColumns, onAddRow, onRemoveRow, onAddColumn, onRemoveColumn }) {
  return (
    <Stack spacing='6'>
      {/* LINHAS DA GRADE */}
      <Box>
        <Flex justify='space-between' align='center' mb='4'>
          <Text fontWeight={600} fontSize='16px'>
            Linhas da Matriz
          </Text>
          <Button
            leftIcon={<IoAddCircleOutline />}
            size='sm'
            colorScheme='blue'
            variant='ghost'
            onClick={() => onAddRow(index)}
          >
            Adicionar linha
          </Button>
        </Flex>
        
        <Stack spacing='12px'>
          {gridRows?.map((row, rowIndex) => (
            <Flex key={row.id || rowIndex} align='center' gap={4}>
              <FormLabel
                htmlFor={`form.${index}.gridRows.${rowIndex}.description`}
                fontSize='14px'
                m={0}
                fontWeight={600}
                minW='30px'
              >
                L{rowIndex + 1}
              </FormLabel>
              <InputText
                {...register(`form.${index}.gridRows.${rowIndex}.description`)}
                error={errors?.form?.[index]?.gridRows?.[rowIndex]?.description}
                placeholder='Ex: Poder de Influência'
              />
              {gridRows.length > 1 && (
                <IconButton
                  icon={<IoTrashOutline />}
                  size='sm'
                  colorScheme='red'
                  variant='ghost'
                  onClick={() => onRemoveRow(index, rowIndex)}
                  aria-label='Remover linha'
                />
              )}
            </Flex>
          ))}
        </Stack>
      </Box>

      {/* COLUNAS DA GRADE */}
      <Box>
        <Flex justify='space-between' align='center' mb='4'>
          <Text fontWeight={600} fontSize='16px'>
            Colunas da Matriz (Opções de resposta)
          </Text>
          <Button
            leftIcon={<IoAddCircleOutline />}
            size='sm'
            colorScheme='blue'
            variant='ghost'
            onClick={() => onAddColumn(index)}
          >
            Adicionar coluna
          </Button>
        </Flex>
        
        <Stack spacing='12px'>
          {gridColumns?.map((col, colIndex) => (
            <Flex key={col.id || colIndex} align='center' gap={4}>
              <FormLabel
                htmlFor={`form.${index}.gridColumns.${colIndex}.description`}
                fontSize='14px'
                m={0}
                fontWeight={600}
                minW='30px'
              >
                C{colIndex + 1}
              </FormLabel>
              <InputText
                {...register(`form.${index}.gridColumns.${colIndex}.description`)}
                error={errors?.form?.[index]?.gridColumns?.[colIndex]?.description}
                placeholder='Ex: Péssimo, Regular, Bom, Ótimo'
              />
              {gridColumns.length > 2 && (
                <IconButton
                  icon={<IoTrashOutline />}
                  size='sm'
                  colorScheme='red'
                  variant='ghost'
                  onClick={() => onRemoveColumn(index, colIndex)}
                  aria-label='Remover coluna'
                />
              )}
            </Flex>
          ))}
        </Stack>
      </Box>

      <Text fontSize='sm' color='gray.600' fontStyle='italic'>
        💡 A grade permitirá que o respondente selecione uma opção por linha (similar ao Google Forms)
      </Text>
    </Stack>
  );
}

export default GridOptions;
